// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjW6","icon":"styles_icon__1Or7s"};